import DomPurify from "isomorphic-dompurify";

const HtmlRenderer = ({
  bgColor,
  htmlContent,
  inEditor
}: {
  bgColor?: string;
  htmlContent?: string;
  inEditor?: boolean;
}) => {
  if (inEditor && !htmlContent) {
    return (
      <div className="flex h-24 items-center justify-center p-2">
        <p className="text-primary text-md font-medium">Add htmlContent prop value to render this component.</p>
      </div>
    );
  }
  return (
    <section id="HtmlRenderer-142" style={{ backgroundColor: bgColor, width: "100%" }}>
      <div dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(htmlContent || "") }} />
    </section>
  );
};

export default HtmlRenderer;
